export default __webpack_public_path__ + "static/media/MAHESH.cb27e365.JPG";